export const getPathLengthCopy = (pathLength) => {
    if(pathLength < 1000) {
        return `${pathLength}m`;
    } else {
        // Arrotondo a una cifra decimale lavorando in unità da 100m, così
        // l'eventuale riporto (es. 1950m -> 20 decimi) incrementa i km.
        const hectometers = Math.round(pathLength / 100);
        const kilometers = Math.floor(hectometers / 10);
        const decimal = hectometers % 10;
        return `${kilometers}${decimal > 0 ? `.${decimal}` : ''}km`;
    }
}